<template>
  <div></div
></template>

<script>
export default {
  name: 'empty'
};
</script>



// WEBPACK FOOTER //
// src/components/Empty.vue